export function DisplayTextWithLinks( {text}) {
  if (!text) {
    return text;
  }

  // URLs erkennen und umwandeln
  const urlPattern = new RegExp('^(https?:\\/\\/)?' + // protocol
    '((([a-z\\d]([a-z\\d-]*[a-z\\d])*)\\.)+[a-z]{2,}|' + // domain name
    '((\\d{1,3}\\.){3}\\d{1,3}))' + // OR ip (v4) address
    '(\\:\\d+)?(\\/[-a-z\\d%_.~+]*)*' + // port and path
    '(\\?[;&a-z\\d%_.~+=-]*)?' + // query string
    '(\\#[-a-z\\d_]*)?$', 'i'); // fragment locator

  const linkifiedText = text.split(' ').map((word, index) => {
    // Umschliessende Satzzeichen (z.B. Klammern, Anfuehrungszeichen vorn, Punkt/Komma/Semikolon hinten)
    // abtrennen, damit URLs mit direkt anschliessender Interpunktion trotzdem erkannt werden.
    const match = word.match(/^([([{"'\u201e\u201a]*)(.*?)([.,;:!?)\]}"'\u2018\u2019]*)$/);
    const [, leading, core, trailing] = match || ['', '', word, ''];

    const isUrl = core.length > 0 && urlPattern.test(core);

    return isUrl
      ? <span key={index}> {leading}<a href={core} target="_blank" rel="noopener noreferrer">{core}</a>{trailing} </span>
      : <span key={index}> {word} </span>;
  });

  return linkifiedText;
}
